import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom, delayWhen } from 'rxjs/operators';
import { checkPermissions } from '../../users/user.utils';
import { LoggedInUser, UserRoles } from '../../users/users.models';

export const authorizeEffect =
    <T extends Action>(
        user$: Observable<LoggedInUser | undefined>,
        roleCallback: (source: T, user: LoggedInUser | undefined) => UserRoles[]
    ) =>
    (source: Observable<T>) => {
        return source.pipe(
            delayWhen(() => user$.pipe(filter((lu) => lu !== undefined))),
            withLatestFrom(user$),
            filter(([a, user]) => {
                const roles = roleCallback(a, user);
                return user ? checkPermissions(user, roles) : false;
            }),
            map(([a, user]) => a)
        );
    };
